module.exports = __webpack_public_path__ + "media/images/icons/upload-line-3921bdf1e61cdafa45f36f6f9ad2e729.svg";